import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from '@material-ui/core';

import { formatDate } from '../../../common/formatter';
import { UserTrainingUpcoming } from '../../../user/User.interface';

export interface TrainingUpcomingDialogProps {
  open: boolean;
  onCancel?: () => void;
  onCreated?: () => void;
  upcomingTrainings?: UserTrainingUpcoming[];
}

const TrainingUpcomingDialog: React.FC<TrainingUpcomingDialogProps> = ({
  open,
  onCancel,
  upcomingTrainings
}) => {
  return (
    <Dialog open={open} onClose={onCancel}>
      <DialogTitle id='alert-dialog-title'>{'Upcoming trainings'}</DialogTitle>

      <DialogContent>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Training</TableCell>
                <TableCell>Deadline</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {upcomingTrainings &&
                upcomingTrainings.map(
                  (upcomingTraining: UserTrainingUpcoming) => (
                    <TableRow key={upcomingTraining.trainingId}>
                      <TableCell>{upcomingTraining.trainingName}</TableCell>
                      <TableCell>
                        {formatDate(upcomingTraining.trainingDeadline)}
                      </TableCell>
                    </TableRow>
                  )
                )}
            </TableBody>
          </Table>
        </TableContainer>
      </DialogContent>

      <DialogActions>
        <Button onClick={onCancel} variant='contained' color='primary'>
          Okay
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default TrainingUpcomingDialog;
